import React from "react";
import {className} from "../format.js";

export function Badge({value}) {
    const display = String(value || "unknown").replaceAll("_", " ");
    return <span className={`badge ${className(value)}`}>{display}</span>;
}
